import { inject, Injectable } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { HotToastService } from "@ngxpert/hot-toast";
import { catchError, EMPTY, map, Observable } from "rxjs";
import { ApiService } from "../../../../api/packbo/api.service";
import { createItemsBronzeSubscriptionFormSubmissions } from "../../../../api/packbo/fn/items/create-items-bronze-subscription-form-submissions";
import { ItemsBronzeSubscriptionFormSubmissions } from "../../../../api/packbo/models/items-bronze-subscription-form-submissions";
import { setLoadingState } from "../../../../rxjs/set-loading-state.operator";
import { showSuccessOrErrorToast } from "../../../../rxjs/show-success-or-error-toast.operator";
import { BronzeSubscriptionFormBlockStore } from "./bronze-subscription-form-block.store";

@Injectable()
export class BronzeSubscriptionFormBlockService {
    private readonly store = inject(BronzeSubscriptionFormBlockStore);
    private readonly hotToast = inject(HotToastService);
    private readonly translocoService = inject(TranslocoService);
    private readonly apiService = inject(ApiService);

    public createBronzeSubscriptionFormSubmission(
        form: ItemsBronzeSubscriptionFormSubmissions
    ): Observable<ItemsBronzeSubscriptionFormSubmissions[] | null> {
        return this.apiService.invoke(createItemsBronzeSubscriptionFormSubmissions, { body: form }).pipe(
            setLoadingState(this.store, "submitting"),
            showSuccessOrErrorToast(this.hotToast, {
                message: {
                    success: this.translocoService.translate("bronze_subscription_form_block.toasts.success"),
                    error: this.translocoService.translate("bronze_subscription_form_block.toasts.error")
                }
            }),
            map((res) => {
                return res.data ?? null;
            }),
            catchError(() => EMPTY)
        );
    }
}
